import { ButtonColors } from '@tcl-boron-foundations/base-button/lib/BaseButton';
import { ActionPalette, GrayscalePalette, BrandPalette } from '@tcl-boron-colors/colors';

type PartialColors = Partial<{
  activeColors: Partial<ButtonColors>;
  pressedColors: Partial<ButtonColors>;
  focusColors: Partial<ButtonColors>;
  defaultColors: Partial<ButtonColors>;
  hoverColors: Partial<ButtonColors>;
  disabledColors: Partial<ButtonColors>;
}>;

type Colors = {
  activeColors: ButtonColors;
  pressedColors: ButtonColors;
  focusColors: ButtonColors;
  defaultColors: ButtonColors;
  hoverColors: ButtonColors;
  disabledColors: ButtonColors;
};

const primaryTheme: PartialColors = {
  defaultColors: {
    color: GrayscalePalette[100],
    backgroundColor: ActionPalette[600],
    borderColor: ActionPalette[600],
  },
  hoverColors: {
    color: ActionPalette[100],
    backgroundColor: ActionPalette[500],
    borderColor: ActionPalette[500],
  },
  focusColors: {
    color: GrayscalePalette[100],
    backgroundColor: ActionPalette[600],
    borderColor: ActionPalette[300],
  },
  pressedColors: {
    color: GrayscalePalette[400],
    backgroundColor: ActionPalette[600],
    borderColor: ActionPalette[600],
  },
  disabledColors: {
    color: GrayscalePalette[400],
    backgroundColor: ActionPalette[200],
    borderColor: ActionPalette[200],
  },
};

const secondaryTheme: PartialColors = {
  defaultColors: {
    color: ActionPalette[600],
    backgroundColor: 'transparent',
    borderColor: ActionPalette[600],
  },
  hoverColors: {
    color: ActionPalette[100],
    backgroundColor: ActionPalette[500],
    borderColor: ActionPalette[500],
  },
  focusColors: {
    color: BrandPalette[700],
    backgroundColor: 'transparent',
    borderColor: ActionPalette[300],
  },
  pressedColors: {
    color: ActionPalette[600],
    backgroundColor: ActionPalette[200],
    borderColor: ActionPalette[500],
  },
  disabledColors: {
    color: GrayscalePalette[400],
    backgroundColor: 'transparent',
    borderColor: ActionPalette[200],
  },
};

const tertiaryTheme: PartialColors = {
  defaultColors: {
    color: ActionPalette[600],
    borderStyle: 'solid',
    borderColor: 'transparent',
    backgroundColor: 'transparent',
  },
  hoverColors: {
    color: ActionPalette[600],
    borderStyle: 'solid',
    borderColor: ActionPalette[500],
    backgroundColor: 'transparent',
  },
  focusColors: {
    color: ActionPalette[600],
    borderStyle: 'solid',
    borderColor: ActionPalette[300],
    backgroundColor: 'transparent',
  },
  pressedColors: {
    color: GrayscalePalette[500],
    borderStyle: 'solid',
    backgroundColor: 'transparent',
    borderColor: 'transparent',
  },
  disabledColors: {
    color: GrayscalePalette[400],
    borderColor: 'transparent',
    borderStyle: 'solid',
    backgroundColor: 'transparent',
  },
};

export const getButtonColorsForButtonType = (buttonType: string): Colors => {
  switch (buttonType) {
    case 'primary': {
      const styles: PartialColors = primaryTheme;
      return styles as Colors;
    }
    case 'secondary': {
      const styles: PartialColors = secondaryTheme;
      return styles as Colors;
    }
    case 'tertiary': {
      const styles: PartialColors = tertiaryTheme;
      return styles as Colors;
    }
  }
};

export const getSecondaryButtonColors = (): Colors => {
  const styles: PartialColors = secondaryTheme;
  return styles as Colors;
};

export const getTertiaryButtonColors = (): Colors => {
  const styles: PartialColors = tertiaryTheme;
  return styles as Colors;
};
